import { PageActionBar } from "components/PageActionBar";
import { useEligibilityActivity } from "pages/CreateOrder/hooks/eligibilityActivity";
import { useOrderReadiness } from "pages/CreateOrder/hooks/useOrderReadiness";
import { ReactNode } from "react";

/** The order pages' action bar: the shared sticky bar plus the readiness hint. */
export function StickyFooter({ children }: { children: ReactNode }) {
  const isReady = useOrderReadiness();
  // CLE-2971 — `useOrderReadiness` is false while a check is pending; say so, not "required fields".
  const isCheckingEligibility = useEligibilityActivity();

  let hint = "Please, fill in all required fields to create estimate";
  if (isCheckingEligibility) hint = "Checking eligibility, one moment…";
  else if (isReady) hint = "Ready to generate and send";

  return (
    <PageActionBar>
      <span className="footer-hint" data-testid="pageActionsHint">
        {hint}
      </span>

      {children}
    </PageActionBar>
  );
}
